<template>
  <div class="default-nodata">
    <img src="../../assets/images/icon-default-nodata-bg.png" alt />
    <p class="nodata-tips">{{text}}</p>
  </div>
</template>

<script>
export default {
  name: 'DefaultPage',
  props: ['text']
}
</script>



// WEBPACK FOOTER //
// src/components/common/DefaultPage.vue